import React from 'react';
import { CalendarIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { formatEventDate } from '@dashboard/lib/format-date';
import getProductPriceLabel from '@dashboard/services/translation/getProductPriceLabel';
import clsx from 'clsx';
import { productTypes } from '@dashboard/enums/product-types';
import checkIsEventSoldOut from '@dashboard/services/event/checkIsEventSoldOut';
import StatusBadge from '@/dashboard/components/StatusBadge';

const PageOverviewHeader = ({ page, children }) => {
  const { eventDetails, product } = page;
  const isEvent = page.type === 'event';
  const isCheckout = page.type === 'checkout';
  const isForm = page.type === 'form';
  const isCharge = page.productType === productTypes.CHARGE;
  const isSubscription = page.productType === productTypes.SUBSCRIPTION;

  return (
    <div className="grid md:grid-cols-10 gap-x-2 gap-y-4 items-stretch">
      <div
        className={`col-span-4 border border-gray-100 rounded p-4 flex flex-col justify-center gap-y-1`}
      >
        <div className={`text-xl font-semibold flex gap-x-2`}>
          <div>{page.name}</div>
        </div>

        {isEvent && (
          <>
            <div>
              {eventDetails.startDate && (
                <div className="flex items-center gap-x-2 justify-start">
                  <div>
                    <CalendarIcon className="h-5 w-5" />
                  </div>
                  <div className="flex flex-col font-medium text-sm">
                    {formatEventDate({
                      startDate: eventDetails.startDate,
                      endDate: eventDetails.endDate,
                      timezone: eventDetails.timezone,
                    }).map(date => (
                      <span key={date}>{date}</span>
                    ))}
                  </div>
                </div>
              )}

              {eventDetails.location && (
                <div className="flex items-center gap-x-2 justify-start text-sm">
                  <div>
                    <MapPinIcon className="h-5 w-5" />
                  </div>
                  {eventDetails.mapsLink && (
                    <a
                      href={eventDetails.mapsLink}
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="font-medium underline"
                    >
                      {eventDetails.location}
                    </a>
                  )}

                  {!eventDetails.mapsLink && (
                    <span className="font-medium">{eventDetails.location}</span>
                  )}
                </div>
              )}
              <div className="mt-2">
                {page.eventDetails?.status === 'canceled' ? (
                  <StatusBadge status="canceled" label="Canceled" />
                ) : checkIsEventSoldOut(page) ? (
                  <StatusBadge status="sold_out" label="Sold out"></StatusBadge>
                ) : null}
              </div>
            </div>
          </>
        )}

        {isCheckout && <div className="text-2xl">{getProductPriceLabel(product, page.locale)}</div>}
      </div>

      <div className={`col-span-6 flex`}>
        <div
          className={clsx(
            `grid gap-2 flex-1`,
            (isForm || isSubscription) && 'md:grid-cols-3',
            (isCharge || isEvent) && 'md:grid-cols-4',
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageOverviewHeader;
